import { getShop, saveDefaultProject } from '@/api/api'
import { startOfDay } from 'date-fns'
import cloneDeep from 'lodash-es/cloneDeep'
import { useAddressBookStore } from '@/stores/AddressBook.store'
import { useFileListStore } from '@/stores/FileList.store'
import { useShopsStore } from '@/stores/Shops.store'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import { mapStores } from 'pinia'
import Cookies from 'js-cookie'
import { UPLOAD_COOKIE } from '@/stores/store'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapStores(useAddressBookStore, useShopsStore, useCheckOutStore)
  },
  methods: {
    setDeliveryAddress() {
      let delAddress = {}

      const addresses = this.addressBookStore.deliveryAddresses
      delAddress =
        addresses.find((address) => address.default) || addresses[0] || {}

      return delAddress
    },
    getDefaultInvoiceDetails() {
      let invAddress = {}
      let project = {}
      let reference = ''

      const addresses = this.addressBookStore.invoiceAddresses

      invAddress = addresses.find((address) => address.default) ||
        addresses[0] || {
          projects: [],
          references: []
        }

      if (this.rootStore.theme.customFields.project.useFormatString) {
        project = {
          name: this.rootStore.user.formatString,
          id: 0
        }
      } else if (this.rootStore.user.defaultProjectId === 0) {
        project = {
          name: '',
          id: 0
        }
      } else if (invAddress.projects && invAddress.projects.length === 1) {
        project = {
          name: invAddress.projects[0].name,
          id: invAddress.projects[0].id
        }
      } else if (
        this.rootStore.user.defaultProjectId &&
        invAddress.projects &&
        invAddress.projects.length > 1
      ) {
        project = invAddress.projects.find(
          (p) => p.id == this.rootStore.user.defaultProjectId
        ) || {
          name: '',
          id: 0
        }
      } else {
        project = {
          name: '',
          id: 0
        }
      }

      reference =
        invAddress.references && invAddress.references.length === 1
          ? invAddress.references[0].value
          : ''

      const invoiceDetails = {
        address: invAddress,
        project: project,
        reference: reference
      }

      //return invAddress
      return invoiceDetails
    },
    setShop(delAddr, invId, secure) {
      return new Promise((resolve, reject) => {
        getShop(delAddr, invId, secure).then((resp) => {
          const shop = this.shopsStore.shopsList.find(
            (shop) => resp.location.id === shop.id
          )
          resolve(shop)
        })
      })
    },
    preparePrintStoreCart(cart) {
      let products = cloneDeep(cart)

      products.forEach((product) => {
        product.printType = 'PRINT_STORE'

        if (product.type === 'package') {
          product.products.forEach((pr) => {
            pr.printSpecification.productcode = product.productCode || ''
          })
        } else {
          product.printSpecification.productcode = product.productCode || ''
          if (product.volumeQuantity) {
            product.quantity = parseInt(product.volumeQuantity)
          }
        }

        if (product.customImages?.length > 0) {
          product.customImages.forEach((cImage) => {
            product.printSpecification[cImage.title] = cImage.images.map(
              (img) => img.name
            )
          })
        }

        if (product.isStockProduct) {
          product.printSpecification.voorraadproduct = 'JA'
        }
      })

      return products
    },
    prepareLegacyPrintFile(file) {
      let productionSpecs

      if (file.productSpecs && file.productSpecs.title) {
        productionSpecs = {
          Product: file.productSpecs.title,
          ...file.productSpecs
        }
        delete productionSpecs.title
        delete file.format
        delete file.colorMode
        delete file.side
        delete file.material
        delete file.treatment

        file.printType = 'PRINT_TEMPLATE'
      } else {
        file.printType = 'PRINT_CUSTOM'
        productionSpecs = {
          Product: 'Zelf samenstellen',
          Printopties: [file.format, file.colorMode, file.side, file.material]
        }

        if (file.treatment) {
          productionSpecs.Afwerking = [file.treatment]
        }
      }

      file.productionSpecs = productionSpecs

      return file
    },
    prepareProductFile(file) {
      //naam van bijlage bestand ntbreekt, dus toevoegen aan productSpecs
      file.printType = 'PRINT_PRODUCT'
      file.format = ''
      file.material = ''
      file.colorMode = ''
      file.side = ''
      file.treatment = ''
      file.productSpecs.Product = file.productSpecs.title

      file.secured = file.productSpecs.secured || false
      //console.log(file)
      // file.quantity = file.productSpecs.quantity

      if ('priceType' in file.productSpecs) {
        delete file.productSpecs.priceType
      }

      if (Array.isArray(file.productSpecs.specs)) {
        const productionSpecs = { Product: file.productSpecs.title }

        for (let i = 0; i < file.productSpecs.specs.length; i++) {
          const spec = file.productSpecs.specs[i]

          // Build productionSpecs grouped by productionCategory
          if (
            spec.productionCategory &&
            spec.optionName !== 'NONE' &&
            (spec.productionTitle || spec.optionTitle)
          ) {
            if (!productionSpecs[spec.productionCategory]) {
              productionSpecs[spec.productionCategory] = []
            }
            productionSpecs[spec.productionCategory].push(
              spec.productionTitle || spec.optionTitle
            )
          }

          if (
            !file.productSpecs.userTemplate &&
            (spec.optionTitle === '' || spec.optionName === 'NONE')
          ) {
            continue
          }

          const title = spec.title

          if (!file.productSpecs.hasOwnProperty(title)) {
            file.productSpecs[title] = [spec.optionTitle]
          } else {
            file.productSpecs[title].push(spec.optionTitle)
          }
        }

        file.productionSpecs = productionSpecs
      } else {
        file.productSpecs = { ...file.productSpecs, ...file.productSpecs.specs }
      }

      if (file.productSpecs.files?.length > 0) {
        file.productSpecs.files.forEach((entry) => {
          if (entry.type === 'ADDRESS_LIST') {
            file.addressList = entry.name
            if (file.productionSpecs) {
              file.productionSpecs.Adressenbestand = entry.name
            }
          } else if (entry.type === 'ATTACHMENT_FILE') {
            file.attachmentFile = entry.name
            if (file.productionSpecs) {
              file.productionSpecs['Bijlage bestand'] = entry.name
            }
          }
        })
        delete file.productSpecs.files
      }

      if (
        !this.rootStore.theme.customFields.productOrder?.calculatePrice ||
        file.productSpecs.hidePrice ||
        file.price === 'NA'
      ) {
        delete file.price
      }

      delete file.dpisPerPage
      delete file.productSpecs.userTemplate
      delete file.productSpecs.title
      delete file.productSpecs.specs
      delete file.productSpecs.secured
      delete file.productSpecs.alwaysColor
      delete file.productSpecs.hidePrice
      delete file.productSpecs.OrderAfwerking
      //      delete file.productSpecs.quantity
      //console.log(file)
      return file
    },
    prepareOrder(orderDetails) {
      const order = cloneDeep(orderDetails)

      const checkOutStore = useCheckOutStore()
      const deliveryAddressIncludedInFiles =
        checkOutStore.deliveryAddressIncludedInFiles

      order.email = this.rootStore.user.username
      order.phone = orderDetails.phone || this.rootStore.user.phone || null
      order.orderedBy = this.rootStore.user.name
      order.userId = this.rootStore.user.uid

      if (!this.rootStore.theme.customFields.hideInvoiceOptions) {
        //set projectname + inv address default for next order

        saveDefaultProject(order.project.id)
        this.rootStore.setDefaultProject(order.project.id)

        // project & ref logic
        order.project = order.project.name

        //check and set quoteno.
        if (order.quotationNo) {
          order.instruction = order.instruction.replace(
            /^/,
            'Offertenummer: ' + order.quotationNo + '\n\n'
          )
        }
        delete order.quotationNo

        //combine project / ref
        if (
          this.rootStore.theme.customFields.mergeProjectReference &&
          order.reference
        ) {
          let mergeSymbol = this.rootStore.theme.customFields.mergeSymbol || '/'

          order.project = order.project + mergeSymbol + order.reference
          order.reference = ''
        }

        // Truncate project to max 35 characters
        if (order.project && order.project.length > 35) {
          order.project = order.project.substring(0, 35)
        }

        //        order.invoiceAddress.id = order.invoiceAddress.customerNumber
        if (order.invoiceAddress.newCustomer) {
          order.requestNewCustomer = true

          if (order.invoiceAddress.customerNumber) {
            order.customerNumber = parseInt(order.invoiceAddress.customerNumber)
          }
        } else {
          this.addressBookStore.setInvAddressDefault(
            order.invoiceAddress.customerNumber
          )
          order.requestNewCustomer = false
          order.customerNumber = parseInt(order.invoiceAddress.customerNumber)
        }
      }

      if (
        !this.rootStore.theme.customFields.hideDeliverOptions &&
        !deliveryAddressIncludedInFiles
      ) {
        //check if constructionsite

        if (order.deliveryAddress.isConstructionSite) {
          order.instruction = order.instruction.replace(
            /^/,
            'Let op: bezorgadres betreft een bouwplaats. \n\n'
          )
        }

        //set name if pickup
        if (order.orderType === 'pickUp') {
          order.deliveryAddress.name = this.rootStore.user.name
        }

        if (!order.deliveryDate || !order.deliveryDate.value) {
          delete order.deliveryDate
        } else if (order.deliveryDate.title === 'spoed') {
          order.express = true
          delete order.deliveryDate
        } else {
          // Safety check: prevent orders with a delivery date in the past
          const selectedDate = startOfDay(new Date(order.deliveryDate.value))
          const today = startOfDay(new Date())

          order.deliveryDate = order.deliveryDate.value
        }
      }

      if (order.orderType === 'scanOrder' || order.orderType === 'copyOrder') {
        order.pickupAddress = order.pickUpAddress
        order.pickupDate = order.pickUpDate.value
        delete order.pickUpAddress
        delete order.orderType
        delete order.orderedBy
        delete order.userId
      } else {
        order.cart = []
        const fileListStore = useFileListStore()
        order.sessionId = Cookies.get(UPLOAD_COOKIE)
      }

      delete order.deliveryAddress.deliveryAddress
      delete order.deliveryAddress.deliveryAddressDefault
      delete order.deliveryAddress.invoiceAddress
      delete order.deliveryAddress.invoiceAddressDefault
      delete order.deliveryAddress.isEditable
      delete order.deliveryAddress.default

      if (order.requestNewCustomer && order.customerNumber) {
        delete order.invoiceAddress
      } else {
        delete order.invoiceAddress.project
        delete order.invoiceAddress.reference
        delete order.invoiceAddress.deliveryAddress
        delete order.invoiceAddress.deliveryAddressDefault
        delete order.invoiceAddress.invoiceAddress
        delete order.invoiceAddress.invoiceAddressDefault
        delete order.invoiceAddress.isEditable
        delete order.invoiceAddress.projects
        delete order.invoiceAddress.references
        delete order.invoiceAddress.default
      }

      if (this.rootStore.theme.customFields.kvdmPortal) {
        order.customerNumber = parseInt(
          this.rootStore.theme.customFields.themeCustomer
        )
        order.upstreamCustomerNumber = order.invoiceAddress.customerNumber

        order.sourceSystem = 'KVDM'
        delete order.invoiceAddress
      }

      if (this.rootStore.theme.customFields.sapPortal) {
        delete order.deliveryAddress
        delete order.invoiceAddress
        delete order.deliveryDate
        delete order.project
        delete order.reference
        order.customerNumber = parseInt(
          this.rootStore.theme.customFields.themeCustomer
        )
      }

      if (deliveryAddressIncludedInFiles) {
        order.deliveryAddress = {
          company: 'PostNL',
          city: 'PostNL',
          street: 'PostNL'
        }

        order.deliveryDate = order.deliveryDate.value
        //delete order.deliveryDate
      }

      // strip externalId when empty so the key is omitted from the order
      if (!order.externalId) {
        delete order.externalId
      }

      if (this.rootStore.theme.customFields.orderRedirect) {
        order.redirectAfterSubmit = true
      }

      //set order stuff
      order.themeID = this.rootStore.theme.themeID
      order.mainThemeName = this.rootStore.theme.mainThemeName
      return order
    }
  }
}
